/**
 * 겉모습 스킨 — 토큰 값 한 벌을 통째로 갈아끼우는 스위치다.
 *
 * 🔴 왜 앱마다 다른 CSS 가 아니라 `<html data-skin>` 하나인가:
 *    컴포넌트는 앱 4개가 공유한다. 겉모습을 컴포넌트 CSS 에서 분기하면 같은 파일 안에
 *    앱 이름이 박힌다 — 앱이 늘 때마다 CSS 를 고쳐야 한다. 속성 한 개면 토큰만 갈린다.
 *
 * `console` 스킨 = eric 확정 2026-09-22 「방안 A · 차분한 장비 콘솔」.
 *   통합 콘솔(`apps/console`)과 모듈 앱 3개(`apps/centrifuge` · `apps/assembler` · `apps/liquid-handler` —
 *   2026-10-16~18 부터 콘솔 장비 판을 그대로 쓴다)가 단다. `apps/console-equipment` 만 속성을 달지 않아
 *   `:root` 의 종전 흑백 토큰으로 선다.
 */
export const SKINS = ['console'] as const

export type Skin = (typeof SKINS)[number]

/** 첫 렌더 전에 `<html>` 에 박는다(테마와 같은 시점 · mountApp). */
export function applySkin(root: HTMLElement, skin: Skin): void {
  root.dataset.skin = skin
}

/**
 * 스킨이 서 있는가 — **겉모습 «취향» 줄을 그릴지**의 판정이다.
 *
 * 🔴 강조색·유리 효과는 콘솔 스킨 팔레트 아래에만 서 있다. 내 계정 화면은 앱 5개가
 *    공유하므로(`apps/console-equipment` 도 같은 `AccountContainer` 를 쓴다) 그 앱들에
 *    아무 일도 안 하는 줄을 세우면 안 된다 — 「눌러도 안 바뀌는 설정」이 된다.
 * ⚠ 「권한 없는 버튼은 숨기지 않는다」와 다른 사안이다. 이건 권한이 아니라 **그 표면에
 *   존재하지 않는 기능**이다(사유를 적어 봐야 사용자가 할 수 있는 일이 없다).
 */
export function hasSkin(): boolean {
  if (typeof document === 'undefined') return false
  const value = document.documentElement.dataset['skin']
  return (SKINS as readonly string[]).includes(value ?? '')
}
